import CitySEOHead from "@/components/feature/CitySEOHead";
import BocaHeroSection from "./components/HeroSection";
import BocaStickyNav from "./components/StickyNav";
import BocaProcessingTimeSection from "./components/ProcessingTimeSection";
import BocaServicesSection from "./components/ServicesSection";
import BocaLocalAreaSection from "./components/LocalAreaSection";
import BocaTestimonialsSection from "./components/TestimonialsSection";
import BocaAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import BocaComparisonSection from "./components/ComparisonSection";
import BocaMistakesSection from "./components/MistakesSection";
import BocaHowItWorksSection from "./components/HowItWorksSection";
import BocaFAQSection, { faqs } from "./components/FAQSection";
import BocaHelpfulResourcesSection, { landmarks as bocaLandmarks } from "./components/HelpfulResourcesSection";
import BocaFinalCTA from "./components/FinalCTA";
import BocaTravelTimingSection from "./components/TravelTimingSection";
import BocaDestinationsSection from "./components/DestinationsSection";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const pageTitle = "Emergency Passport Boca Raton, FL — Expedited & Fast Passport Service | Fast Passport Center";
const pageDescription = "Emergency and expedited passport services in Boca Raton, FL — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving South Florida travelers.";

const areaServedList = [
  { "@type": "City", name: "Boca Raton" },
  { "@type": "City", name: "Delray Beach" },
  { "@type": "City", name: "Deerfield Beach" },
  { "@type": "City", name: "Boynton Beach" },
  { "@type": "City", name: "Highland Beach" },
  { "@type": "City", name: "Parkland" },
  { "@type": "City", name: "Coconut Creek" },
  { "@type": "City", name: "Lighthouse Point" },
  { "@type": "AdministrativeArea", name: "Palm Beach County" },
];

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function BocaPage() {
  return (
    <>
      <CitySEOHead
        city="Boca Raton"
        state="Florida"
        stateAbbr="FL"
        route="/cities/boca-raton"
        title={pageTitle}
        description={pageDescription}
        ogTitle={pageTitle}
        ogDescription={pageDescription}
        twitterTitle={pageTitle}
        twitterDescription={pageDescription}
        geoPlacename="Boca Raton, Florida"
        geoPosition="26.3683;-80.1289"
        keywords="expedited passport Boca Raton, emergency passport Boca Raton FL, same day passport Boca Raton, fast passport Florida, passport renewal Boca Raton, South Florida passport"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Florida"
        statePageRoute="/states/florida"
        lastModified="2026-06-09"
        areaServedList={areaServedList}
        serviceAreaDesc="Fast Passport Center does not have a physical office in Boca Raton — we serve this area remotely. Emergency and expedited passport services as fast as 24 hours for Boca Raton and South Florida travelers."
        landmarks={bocaLandmarks}
      />

      <div className="font-sans">
      <BocaHeroSection />
      <BocaStickyNav />
      <BocaLocalAreaSection />
      <BocaProcessingTimeSection />
      <BocaServicesSection />
      <BocaTravelTimingSection />
      <BocaDestinationsSection />
      <BocaTestimonialsSection />
      <BocaAcceptanceFacilitiesSection />
      <BocaComparisonSection />
      <BocaMistakesSection />
      <BocaHowItWorksSection />
      <BocaFAQSection />
      <BocaHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/boca-raton" state="FL" />
      <BocaFinalCTA />
      </div>
    </>
  );
}